// core/_requests.ts
import RequestBase from '../../../api/RequestBase'
import type {BaeSurveyValues} from '../BaeSurvey'
import type {AxiosRequestConfig} from 'axios'

const BASE_URL = '/survey'

const sendBaeSurvey = (payload: BaeSurveyValues, config?: AxiosRequestConfig) => {
  return RequestBase.post(`${BASE_URL}/bae-survey`, payload, config)
}

const SurveyService = {
  sendBaeSurvey,
}

export default SurveyService
